"use client";

import * as React from "react";

import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import twMerge from "@replo/design-system/utils/twMerge";
import { Check } from "lucide-react";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    icon?: React.ReactNode;
    indicatorClassName?: string;
  }
>(({ className, icon, indicatorClassName, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={twMerge(
      "border-0.5 border-border focus-visible:ring-ring data-[state=checked]:border-primary data-[state=checked]:bg-primary focus-visible:outline-hidden peer flex h-4 w-4 shrink-0 items-center justify-center rounded-sm bg-white ring-offset-transparent focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:text-white",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={twMerge(
        "flex items-center justify-center text-current",
        indicatorClassName,
      )}
    >
      {icon ?? <Check className="h-4 w-4" />}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
